import { render, staticRenderFns } from "./documentsPublic.vue?vue&type=template&id=811bfc92&scoped=true&"
import script from "./documentsPublic.vue?vue&type=script&lang=js&"
export * from "./documentsPublic.vue?vue&type=script&lang=js&"
import style0 from "./documentsPublic.vue?vue&type=style&index=0&id=811bfc92&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811bfc92",
  null
  
)

export default component.exports